import { Reveal } from '@/components/ui/reveal';
import { TestimonialCard, type Testimonial } from './testimonial-card';

// TODO(#203): PLACEHOLDER COPY — these four quotes and the people in them are
// invented, and the avatars are stock illustrations, not photographs of
// customers. Replace with real, attributable quotes (with written permission)
// before this page goes in front of customers. Shipping invented testimonials
// on a commercial page is a consumer-protection problem, not just a polish one.
const TESTIMONIALS: Testimonial[] = [
  {
    name: 'Ravi K.',
    location: 'Hyderabad plot owner · based in the US',
    plot: 'Residential plot, Kokapet',
    avatar: '/avatars/avatar-1.svg',
    quote:
      "I hadn't seen my plot in three years. The first report caught a boundary marker that had shifted, which a relative dropping by would never have picked up. I sorted it out with the local authority before it became a real problem.",
  },
  {
    name: 'Joseph N.',
    location: 'Vijayawada plot owner · based in the UK',
    plot: 'Agricultural land, outskirts of Vijayawada',
    avatar: '/avatars/avatar-2.svg',
    quote:
      "Coordinating a watchman from abroad never got me a straight answer. Now I get photos and video every visit, so I actually know what's happening instead of taking someone's word for it.",
  },
  {
    name: 'Suresh P.',
    location: 'Guntur plot owner · based in Dubai',
    plot: 'Vacant residential plot',
    avatar: '/avatars/avatar-3.svg',
    quote:
      'Signing up took less time than the paperwork for my last bank KYC. The reports are clear enough that I forward them straight to my brother, who handles things locally when I need a second pair of eyes.',
  },
  {
    name: 'Priya M.',
    location: 'Bangalore plot owner · based in Singapore',
    plot: 'Vacant plot, Sarjapur Road',
    avatar: '/avatars/avatar-4.svg',
    quote:
      'Someone had started dumping construction debris along the back edge of my plot. It showed up in the report with photos before it turned into a proper problem, and my cousin got it cleared the same week.',
  },
];

/**
 * Bento grid · 4 tiles on a 4×2 lg grid:
 *   featured  cols 1-2 / rows 1-2   (tall anchor, display-size quote)
 *   wide      cols 3-4 / row 1
 *   small     col 3 / row 2
 *   small     col 4 / row 2
 * Collapses to 2-up at md and a single column on phones.
 */
export function Testimonials() {
  const [featured, wide, ...rest] = TESTIMONIALS;

  return (
    <section className="mx-auto max-w-6xl px-4 py-14 sm:px-6 sm:py-20 md:py-28">
      <Reveal className="max-w-2xl">
        <h2 className="font-display text-3xl font-medium leading-tight tracking-tight text-foreground [overflow-wrap:anywhere] md:text-4xl">
          Trusted by owners watching their land from afar.
        </h2>
      </Reveal>

      {/* `[&>figure]:h-full` — Reveal wraps each tile in a div, so the card needs
          to stretch through that wrapper to fill its grid track. */}
      {/* Rows are auto-sized, not `grid-rows-2`: fixed equal rows sized themselves
          to the tall featured tile and left a ~200px void inside the wide one. */}
      <div className="mt-10 grid gap-4 sm:mt-14 md:grid-cols-2 lg:grid-cols-4">
        <Reveal className="md:col-span-2 lg:row-span-2 [&>figure]:h-full">
          <TestimonialCard testimonial={featured} featured />
        </Reveal>
        <Reveal delay={0.06} className="md:col-span-2 [&>figure]:h-full">
          <TestimonialCard testimonial={wide} />
        </Reveal>
        {rest.map((testimonial, idx) => (
          <Reveal key={testimonial.name} delay={0.12 + idx * 0.06} className="[&>figure]:h-full">
            <TestimonialCard testimonial={testimonial} />
          </Reveal>
        ))}
      </div>
    </section>
  );
}
